<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import moment from 'moment';

import CommunicationsTable from './CommunicationsTable';

export default {
  page: {
    title: 'Communications',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, CommunicationsTable },
  data() {
    let $this = this;
    return {
      title: 'Communications',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Communications', active: true, },
      ],

      pickeroptions: {
        shortcuts: [
          { text: 'This week', onClick (picker) { picker.$emit('pick', [moment().startOf('week').toDate(), moment().endOf('week').toDate()]); } },
          { text: 'Last week', onClick (picker) { picker.$emit('pick', [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()]); } },
          { text: 'This month', onClick (picker) { picker.$emit('pick', [moment().startOf('month').toDate(), moment().endOf('month').toDate()]); } },
          { text: 'Last month', onClick (picker) { picker.$emit('pick', [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]); } },
          { text: 'This year', onClick (picker) { picker.$emit('pick', [moment().startOf('year').toDate(), moment().endOf('year').toDate()]); } },
          { text: 'Last year', onClick (picker) { picker.$emit('pick', [moment().subtract(1, 'year').startOf('year').toDate(), moment().subtract(1, 'year').endOf('year').toDate()]); } },
          { text: 'All time', onClick (picker) { picker.$emit('pick', [moment().set('year', 2016).toDate(), moment().toDate()]); } },
          { text: 'Clear', onClick (picker) { try { $this.$refs['picker1'].clearDate(); } catch(err) { console.log(err); } } },
        ]
      },
      dateRange: ['',''],
      search: '',

      show_filters: false,
      changes: false,

      loading: true,
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        // onable_id: this.$route.params.id,
        // onable_type: 'App\\User',
        // byable_id: this.$route.params.id,
        // byable_type: 'App\\User',
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        }
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n[0] && n[1] && moment(n[0]).isValid() && moment(n[1]).isValid()) {
        this.filters.betweens.created_at.start = moment(n[0]).startOf('day').format();
        this.filters.betweens.created_at.end = moment(n[1]).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.$refs['CommunicationsTable'].fetchData(); } }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="d-none card-box p-0 position-relative">
            <transition name="fade">
              <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
            </transition>

            <div class="row p-3">
              <div class="col-lg-8">
                <div class="form-inline">
                  <div class="form-group mr-1">
                    <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
                  </div>
                  <div class="form-group mr-1">
                    <v2-datepicker-range lang="en" format="MM-DD-yyyy" ref="picker1" v-model="dateRange" :picker-options="pickeroptions" placeholder="Filter by date created..." @change="changes = true"></v2-datepicker-range>
                  </div>
                  <div class="form-group mr-1">
                    <select class="form-control" v-model="filters.paginate">
                      <option value="50">Per page: (50)</option>
                      <option value="100">Per page: (100)</option>
                      <option value="250">Per page: (250)</option>
                      <option value="500">Per page: (500)</option>
                      <option value="750">Per page: (750)</option>
                      <option value="1000">Per page: (1000)</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="text-lg-right mt-3 mt-lg-0">
                  <a @click="$refs['CommunicationsTable'].fetchData()" class="btn btn-light waves-effect waves-light ml-1"><Icon icon="ri:refresh-line" /></a>
                </div>
              </div>
            </div>
            <div v-if="changes" class="alert alert-info m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
            <div class="row">
              <div class="col-sm-12">

              </div>
            </div>
          </div>

          <CommunicationsTable ref="CommunicationsTable" name="All" :filters="filters" @loadchange="(e) => {loading = e; (!e ? changes = e : '')}"></CommunicationsTable>

        </div>
      </div>

    </div>
  </Layout>
</template>
